import { ArrowDownwardOutlined } from "@mui/icons-material";

const IphoneInstructionPopup = ({ onContinueHere, appIcon }) => {
  return (
    <div className="max-w-md mx-auto p-4">
      <header className="text-center mb-6 flex items-center justify-center">
        <div>
          <img
            src={appIcon}
            alt="App Icon"
            className="w-12 h-12 mr-4 rounded-md"
          />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Light Show Instructions</h1>
          <p className="mt-1 text-gray-600 dark:text-gray-300 text-sm">
            Get set up for the best show experience
          </p>
        </div>
      </header>

      <section className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow space-y-4">
        <p className="text-center muted-text">
          Add our event shortcut to your device to get alerts and join instantly
          when the show starts.
        </p>

        <div className="flex items-start">
          <div className="step-image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 120 169"
              fill="currentColor"
            >
              <g>
                <path d="M60 0l28 28-2 2a586 586 0 0 0-4 4L64 15v90h-8V15L38 34l-4-4-2-2L60 0z"></path>
                <path d="M0 49h44v8H8v104h104V57H76v-8h44v120H0V49z"></path>
              </g>
            </svg>
          </div>
          <p className="muted-text">
            1. Select the{" "}
            <span className="font-medium text-gray-900 dark:text-gray-100">
              'SHARE'
            </span>{" "}
            button below the Safari search bar (follow the blue arrow).
          </p>
        </div>

        <div className="flex items-start">
          <div className="step-image">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                d="M4 4h16v16H4z"
              ></path>
              <path
                fill="currentColor"
                d="M11 8h2v3h3v2h-3v3h-2v-3H8v-2h3z"
              ></path>
            </svg>
          </div>
          <p className="muted-text">
            2. Scroll down to select{" "}
            <span className="font-medium text-gray-900 dark:text-gray-100">
              'ADD TO HOME SCREEN'
            </span>
            , then hit{" "}
            <span className="font-medium text-gray-900 dark:text-gray-100">
              'ADD'
            </span>{" "}
            to accept.
          </p>
        </div>

        <div className="flex items-start">
          <div className="step-image">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
              ></path>
            </svg>
          </div>
          <p className="muted-text">
            3. Open the{" "}
            <span className="font-medium text-gray-900 dark:text-gray-100">
              EVENT ICON
            </span>{" "}
            on your device to enable notifications.
          </p>
        </div>
      </section>

      <div className="mt-4 flex flex-col items-center relative">
        <a
          href="#join"
          className="w-full block text-center bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-medium py-3 px-4 rounded-lg shadow hover:bg-gray-400 dark:hover:bg-gray-600 transition-colors"
          onClick={(e) => {
            e.preventDefault();
            onContinueHere();
          }}
        >
          Has the show started? <br /> Click here to join instantly!
        </a>
        <ArrowDownwardOutlined
          style={{ color: "#24b8e7" }}
          className="arrow-bounce"
          fontSize="large"
        />
      </div>
    </div>
  );
};

export default IphoneInstructionPopup;
